<template>
  <div>
    <list
      ref="refPaymentTypePeriodList"
      sort-by="PeriodoPagoTipoId"
      :refetch-records="fetchPaymentTypesPeriod"
      refetch-records-name="periodoPagoTipos"
      :actions="actions"
      key-field="periodoPagoTipoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deletePaymentTypePeriod"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refPaymentTypePeriodList = ref(null)
    /* Services */
    const {
      fetchPaymentTypesPeriod,
      deletePaymentTypePeriod,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.paymentTypePeriod.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.paymentTypePeriod.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Habilidad',
        routeName: 'apps-human-resources-payment-type-period-edit',
        params: ['periodoPagoTipoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Habilidad',
        params: ['periodoPagoTipoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-payment-type-period-add',
        label: i18n.t('Routes.PaymentTypePeriodAdd'),
        aclAction: 'create',
        aclResource: 'Habilidad',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refPaymentTypePeriodList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchPaymentTypesPeriod,
      deletePaymentTypePeriod,
    }
  },
}
</script>
